<template>
  <div
    class="check-box f-column"
    :class="{'checkbox-checked': value}"
    @click="emit"
    v-validate="errors"
  >
    <slot></slot>

    <div class="validation-output mt-1">
      <slot name="validations"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: [
    'value',
    'errors',
  ],
  methods: {
    emit() {
      this.$emit('input', !this.value);
    },
  },
};
</script>
